import { render, staticRenderFns } from "./PIIBoard.vue?vue&type=template&id=e3177da4&scoped=true&"
import script from "./PIIBoard.vue?vue&type=script&lang=ts&"
export * from "./PIIBoard.vue?vue&type=script&lang=ts&"
import style0 from "./PIIBoard.vue?vue&type=style&index=0&id=e3177da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3177da4",
  null
  
)

export default component.exports